import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    templateUrl: "./society-profile-submenu.component.html"
})
export class SocietyProfileSubmenuComponent {
    public temp;
    constructor(private activatedRoute: ActivatedRoute) {
      this.temp = this.activatedRoute.snapshot.paramMap.get("temp");
    }
}